import { Star } from 'lucide-react';
import { cn } from '@/utils/cn';

interface TestimonialCardProps {
  name: string;
  role: string;
  company: string;
  image: string;
  quote: string;
}

const TestimonialCard = ({ name, role, company, image, quote }: TestimonialCardProps) => {
  const shortQuote = quote.length > 150 ? `${quote.slice(0, 150)}...` : quote;

  return (
    <div className="group relative">
      {/* Base card */}
      <div className="bg-white rounded-2xl p-4 sm:p-8 shadow-sm transition-all duration-300 group-hover:shadow-lg">
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-4 sm:h-5 w-4 sm:w-5 text-[#FFE81A] fill-current" />
          ))}
        </div>
        <p className="mt-4 sm:mt-6 text-sm sm:text-base text-gray-600 line-clamp-4 sm:min-h-[4.5rem]">{shortQuote}</p>
        <div className="mt-4 sm:mt-6 flex items-center gap-3 sm:gap-4">
          <img
            src={image}
            alt={name}
            className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover"
          />
          <div>
            <p className="font-semibold text-dark text-sm sm:text-base">{name}</p>
            <p className="text-xs sm:text-sm text-gray-600">{role}</p>
            <p className="text-xs sm:text-sm text-gray-600">{company}</p>
          </div>
        </div>
      </div>

      {/* Expanded card */}
      {quote.length > 150 && (
        <div 
          className={cn(
            "absolute inset-0 opacity-0 group-hover:opacity-100",
            "transition-all duration-300 transform",
            "pointer-events-none group-hover:pointer-events-auto"
          )}
        >
          <div 
            className={cn(
              "absolute top-0 left-0 right-0 -translate-y-2",
              "bg-white rounded-xl p-4 sm:p-6 shadow-xl",
              "z-50 w-full sm:min-w-[400px]",
              "transform transition-all duration-300",
              "opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100"
            )}
          >
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 sm:h-5 w-4 sm:w-5 text-[#FFE81A] fill-current" />
              ))}
            </div>
            <p className="text-sm sm:text-base text-gray-600">{quote}</p>
            <div className="mt-4 sm:mt-6 flex items-center gap-3 sm:gap-4">
              <img
                src={image}
                alt={name}
                className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover"
              />
              <div>
                <p className="font-semibold text-dark text-sm sm:text-base">{name}</p>
                <p className="text-xs sm:text-sm text-gray-600">{role}</p>
                <p className="text-xs sm:text-sm text-gray-600">{company}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestimonialCard;